import React, { FC, useCallback, useState } from 'react'
import { ListChildComponentProps } from 'react-window'
import ProductPhoto from '../../components/ProductPhoto'
import { money } from '../../common/display'
import BinIcon from '../../icons/bin.svg'
import ThresholdIcon from '../../icons/threshold.svg'
import ThresholdModal from './ThresholdModal'

const LocationInventoryRow: FC<ListChildComponentProps> = ({
  data,
  index,
  style,
}) => {
  const item = data.items[index]
  const [showThresholdModal, setShowThresholdModal] = useState(false)
  const pricePerUnit = `${money(item.price || item.product.price || 0)} / ${item.unit || 'EACH'}`
  const total = money(
    (item.inventory || 0) * (item.price || item.product.price || 0),
  )
  const handleDelete = useCallback(() => {
    if (!data.onDelete) return
    if (!confirm('Are you sure you want to remove the item from location?'))
      return
    data.onDelete(item)
  }, [data.onDelete, item])

  const handleThresholdClick = useCallback(() => {
    setShowThresholdModal(true)
  }, [])

  const handleThresholdSave = useCallback(
    (threshold: number | null) => {
      data.onThresholdUpdate(item.id, threshold)
    },
    [data, item.id],
  )

  const handleThresholdClose = useCallback(() => {
    setShowThresholdModal(false)
  }, [])

  return (
    <div className="order-modal_list-item" style={style}>
      <div className="order-modal_list-product order-snippet -small">
        <div className="order-snippet_col -info -large">
          <div className="order-snippet_image-wrapper">
            <ProductPhoto
              photo={item.product.photo}
              className="order-snippet_image"
            />
          </div>
          <div className="order-snippet_title">{item.product.name}</div>
          <div className="order-snippet_info">
            <div className="order-snippet_sku">{item.product.code}</div>
            {data.multiCatalogEnabled && item.product.erpCatalogName && (
              <div className="order-snippet_erp-catalog">
                {item.product.erpCatalogName}
              </div>
            )}
          </div>
          {data.locationType !== 'bin' && (
            <div
              className="order-snippet_threshold-button-wrapper"
              style={data.onDelete ? { marginRight: 20 } : undefined}
            >
              {item.threshold !== null ||
              item.branchProductThreshold != null ? (
                <button
                  className="order-snippet_threshold-button -active"
                  onClick={handleThresholdClick}
                >
                  <ThresholdIcon />
                  <div style={{ paddingLeft: 10 }}>
                    {item.threshold ?? item.branchProductThreshold}
                  </div>
                </button>
              ) : (
                <button
                  className="order-snippet_threshold-button"
                  onClick={handleThresholdClick}
                >
                  <ThresholdIcon />
                  <div style={{ paddingLeft: 10 }}>Add</div>
                </button>
              )}
            </div>
          )}
          <div className="order-snippet_price">{pricePerUnit}</div>
        </div>
        {data.onDelete && (
          <div className="order-snippet_action" onClick={handleDelete}>
            <BinIcon />
          </div>
        )}
      </div>
      <div className="tile -done -bordered clear-button">
        <button className="tile_count-toggle clear-button">
          {item.inventory ?? 0}
        </button>
      </div>
      <div className="tile -done -bordered">{total}</div>
      {data.locationType !== 'bin' && (
        <ThresholdModal
          isOpen={showThresholdModal}
          onClose={handleThresholdClose}
          onSave={handleThresholdSave}
          currentThreshold={item.threshold}
          globalThreshold={item.branchProductThreshold}
        />
      )}
    </div>
  )
}

export default LocationInventoryRow
